// Адрес пункта меню по коду поверхности.
//
// ⚠ Вынесено из оболочки: адрес нужен и меню, и шапке (логотип, вход), и поиску.

import { surfaces } from "../surfaces/registry";

/**
 * Поверхности, слитые в другую (`docs/04-screens.md`, `S-12`): у пункта меню своей
 * теки нет, он ведёт туда, куда слит, — к якорю раздела. `S-23` «Групи товару і
 * умови» — условия групп внутри списка и карточки поставщика (F-005): якорь —
 * раздел «Потребують умов», он в списке первым. Якорь — часть адреса пункта, поэтому
 * пункт не «текущий», пока человек просто в списке (`activeOptions.includeHash`).
 */
export const MERGED_INTO: Readonly<Record<string, { readonly into: string; readonly hash: string }>> = {
  "S-23": { into: "S-12", hash: "s12-section-setup" },
  // `S-18` «Розбіжності» — блок «Не сходиться» на «Стані даних» (F-031, решение 028).
  "S-18": { into: "S-10", hash: "s10-mismatch" },
};

/** Адрес поверхности по её коду. Нет такой теки — нет и адреса. */
export function pathOf(code: string): string | undefined {
  const target = MERGED_INTO[code]?.into ?? code;
  return surfaces.find((one) => one.code === target)?.path;
}
